import { RequestFileCategoryGroup } from '@core/types';

export * from './request-form-files-route-paths';

export enum RequestFilesPersonType {
  CLIENT = 'client',
  INSTALLER = 'installer',
}

export interface FileLink {
  name: string;
  href?: string;
  /** Явное имя файла для скачивания (с расширением). Если не задано — берётся из URL. */
  filename?: string;
  click?: (event: Event) => void;
  target?: string;
  langId: string;
}

export interface CounterpartiesChecklistsCaption {
  id: number;
  counterpartyId: number; // id клиента для кого загружен файл
  createdId: number; // id того кто загрузил файл
  filePath: string; // Путь файла
  fileName: string; // Имя файла
  fullPath: string; // полынй путь файла вместе с адресом сервера статики
}

export interface FileGroupsWithFilesToSend {
  [groupId: RequestFileCategoryGroup['id']]: number[];
}
